var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "updateProductDiglog",
      attrs: {
        visible: _vm.updateProductDiglog,
        width: "95%",
        "show-close": false,
        offset: 0,
      },
      on: {
        "update:visible": function ($event) {
          _vm.updateProductDiglog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            "padding-top": "0.2rem",
            "font-size": "0.12rem",
            color: "black",
          },
        },
        [
          _c("label", { staticClass: "planInfo" }, [_vm._v("日期及行程")]),
          _c(
            "label",
            { staticStyle: { width: "2%", display: "inline-block" } },
            [_vm._v("项目")]
          ),
          _c(
            "label",
            {
              staticStyle: {
                width: "13%",
                display: "inline-block",
                "text-align": "center",
              },
            },
            [_vm._v("产品名称")]
          ),
          _c(
            "label",
            {
              staticStyle: {
                width: "13.5%",
                display: "inline-block",
                "text-align": "center",
              },
            },
            [_vm._v("产品说明")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.5%", display: "inline-block" } },
            [_vm._v("库存单位")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.5%", display: "inline-block" } },
            [_vm._v("使用时长")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.5%", display: "inline-block" } },
            [_vm._v("使用数量")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.5%", display: "inline-block" } },
            [_vm._v("单项成本")]
          ),
          _c(
            "label",
            { staticStyle: { width: "4%", display: "inline-block" } },
            [_vm._v("单项报价")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.8%", display: "inline-block" } },
            [_vm._v("单项利润")]
          ),
          _c(
            "label",
            { staticStyle: { width: "3.4%", display: "inline-block" } },
            [_vm._v("总成本")]
          ),
          _c(
            "label",
            { staticStyle: { width: "2.9%", display: "inline-block" } },
            [_vm._v("总报价")]
          ),
          _c(
            "label",
            { staticStyle: { width: "2.9%", display: "inline-block" } },
            [_vm._v("总利润")]
          ),
          _c(
            "label",
            {
              staticStyle: {
                width: "3.5%",
                display: "inline-block",
                "text-align": "center",
              },
            },
            [_vm._v("利润率")]
          ),
          _c(
            "label",
            { staticStyle: { width: "2.3%", display: "inline-block" } },
            [_vm._v("汇率")]
          ),
          _c(
            "label",
            { staticStyle: { width: "4.7%", display: "inline-block" } },
            [_vm._v("总成本(￥)")]
          ),
          _c(
            "label",
            { staticStyle: { width: "4.7%", display: "inline-block" } },
            [_vm._v("总报价(￥)")]
          ),
          _c(
            "label",
            { staticStyle: { width: "4%", display: "inline-block" } },
            [_vm._v("总利润(￥)")]
          ),
          _c(
            "label",
            { staticStyle: { width: "4%", display: "inline-block" } },
            [_vm._v("产品状态")]
          ),
        ]
      ),
      _vm.updateProductDataList.length
        ? _c(
            "div",
            _vm._l(_vm.updateProductDataList, function (item, index) {
              return _c("div", { key: index, staticClass: "daybox" }, [
                _c(
                  "div",
                  {
                    staticClass: "dayboxzoom",
                    staticStyle: { padding: "0.05rem", width: "10%" },
                  },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.dateFormatYMD(item.planDate, ".")) + " "
                      ),
                    ]),
                    _c(
                      "label",
                      _vm._l(item.cityList, function (item1, index1) {
                        return _c("span", { key: index1 }, [
                          _vm._v(_vm._s(item1.cityName) + " "),
                          index1 != item.cityList.length - 1
                            ? _c("span", [_vm._v("-")])
                            : _vm._e(),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "0.05rem",
                      "margin-bottom": "0.05rem",
                      width: "89%",
                    },
                  },
                  [
                    _c(
                      "draggable",
                      {
                        attrs: { group: "itxst", animation: "300" },
                        on: { add: _vm.addCommand, start: _vm.onStart },
                        model: {
                          value: item.productList,
                          callback: function ($$v) {
                            _vm.$set(item, "productList", $$v)
                          },
                          expression: "item.productList",
                        },
                      },
                      [
                        _c(
                          "transition-group",
                          { style: _vm.style, attrs: { id: item.planDate } },
                          _vm._l(item.productList, function (item1, index1) {
                            return _c(
                              "div",
                              {
                                key: item.planDay + "-" + index1,
                                staticClass: "productBox",
                                attrs: {
                                  id: item1.id,
                                  stockId: item1.stockId,
                                  productType: item1.productType,
                                  budgetId: item1.budgetId,
                                },
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "label",
                                    staticStyle: {
                                      width: "2.7%",
                                      "padding-left": "0.05rem",
                                    },
                                  },
                                  [_vm._v(_vm._s(item1.budgetType))]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label",
                                    staticStyle: {
                                      width: "15%",
                                      "padding-left": "0.05rem",
                                    },
                                  },
                                  [_vm._v(_vm._s(item1.productName))]
                                ),
                                _c("label", { staticClass: "productDesc" }, [
                                  _vm._v(
                                    _vm._s(item1.stockDetailObj.productDesc)
                                  ),
                                ]),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4.2%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item1.stockDetailObj.priceList
                                          ? item1.stockDetailObj.priceList[0]
                                              .priceCompany
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4.3%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item1.stockDetailObj.priceList
                                          ? item1.stockDetailObj.priceList[0]
                                              .useTime
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "3.5%" },
                                  },
                                  [_vm._v(_vm._s(item1.stockNumber))]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4.3%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item1.stockPrice) +
                                        _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4.3%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item1.ratio) +
                                        _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4.3%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item1.ratio - item1.stockPrice) +
                                        _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "3.8%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item1.stockPrice * item1.stockNumber
                                      ) + _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "3.8%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item1.ratio * item1.stockNumber) +
                                        _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "3.2%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (item1.ratio - item1.stockPrice) *
                                          item1.stockNumber
                                      ) + _vm._s(item1.currency)
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "4%" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          Number(
                                            (
                                              (((item1.ratio -
                                                item1.stockPrice) *
                                                item1.stockNumber) /
                                                item1.ratio) *
                                              100
                                            ).toFixed(2)
                                          )
                                        ) +
                                        "% "
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "2.5%" },
                                  },
                                  [_vm._v(_vm._s(item1.rate))]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "5%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          (
                                            item1.stockPrice *
                                            item1.stockNumber *
                                            item1.rate
                                          ).toFixed(2)
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "5%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          (
                                            item1.ratio *
                                            item1.stockNumber *
                                            item1.rate
                                          ).toFixed(2)
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "5%" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Number(
                                          (
                                            (item1.ratio - item1.stockPrice) *
                                            item1.stockNumber *
                                            item1.rate
                                          ).toFixed(2)
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "label center",
                                    staticStyle: { width: "3%" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(
                                          2,
                                          item1,
                                          item.productList
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                                item1.stockStatus === 2
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "label center",
                                        staticStyle: {
                                          width: "3%",
                                          color: "#B4B2B2",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.recoverData(item1, item)
                                          },
                                        },
                                      },
                                      [_vm._v("恢复")]
                                    )
                                  : _c(
                                      "label",
                                      {
                                        staticClass: "label center",
                                        staticStyle: { width: "3%" },
                                      },
                                      [_vm._v("有效")]
                                    ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            }),
            0
          )
        : _c("div"),
      _c(
        "div",
        {
          staticStyle: {
            "justify-content": "center",
            display: "flex",
            "padding-bottom": "10px",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "2.3rem" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "savebuttom",
                  on: {
                    click: function ($event) {
                      return _vm.saveMove()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "savebuttom",
                  staticStyle: { "margin-left": "75px" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }